import { Injectable, Type } from '@angular/core';

import { FootballScore, IcehockeyPeriodGameScore, ScoreboardType } from '@frontend/sports/betting-offer/feature/model';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';

import { ScoreboardComponentBase } from '../../../scoreboards/scoreboard-base.component';
import { MyBetsEventModel } from '../../models/my-bets-event.model';
import { MyBetsLeaderboardGameScoreboardComponent } from './general/my-bets-leaderboard-game-scoreboard.component';
import { MyBetsPairGameNoScoreboardComponent } from './general/my-bets-pair-game-no-scoreboard.component';
import { MyBetsPenaltyShootoutScoreboardComponent } from './general/my-bets-penalty-shootout-scoreboard.component';
import { MyBetsScoreboardPairComponent } from './general/my-bets-scoreboard-pair.component';
import { MyBetsScoreboardSetComponent } from './general/my-bets-scoreboard-set.component';
import { MyBetsSnookerScoreboardComponent } from './general/my-bets-scoreboard-snooker.component';
import { MyBetsTournamentGameScoreboardComponent } from './general/my-bets-tournament-game-scoreboard.component';
import { MyBetsBaseballScoreboardComponent } from './sport-specific/baseball/my-bets-baseball-scoreboard.component';
import { MyBetsScoreboardDartsComponent } from './sport-specific/darts/my-bets-darts-scoreboard.component';
import { MyBetsScoreboardPeriodGameComponent } from './sport-specific/period-game/my-bets-scoreboard-period-game.component';
import { MyBetsScoreboardSoccerComponent } from './sport-specific/soccer/my-bets-scoreboard-soccer.component';
import { MyBetsScoreboardTennisComponent } from './sport-specific/tennis/my-bets-scoreboard-tennis.component';

@Injectable()
export class MyBetsScoreboardResolveService {
    getComponent(event: MyBetsEventModel): Type<ScoreboardComponentBase> | null {
        if (event.participants.length === 0 && event.scoreboard.type !== ScoreboardType.LeaderboardGame) {
            return MyBetsTournamentGameScoreboardComponent;
        }

        if (event.scoreboard.type !== ScoreboardType.TournamentGame && event.scoreboard.type !== ScoreboardType.LeaderboardGame) {
            if (!event.live) {
                return MyBetsPairGameNoScoreboardComponent;
            }

            switch (event.sport.id) {
                case SportConstant.Cricket:
                case SportConstant.Boxing: {
                    return MyBetsPairGameNoScoreboardComponent;
                }
                case SportConstant.Soccer: {
                    const score = event.scoreboard.getScore<FootballScore>();
                    if (score && score.penaltyShootOutScore) {
                        return MyBetsPenaltyShootoutScoreboardComponent;
                    }

                    return MyBetsScoreboardSoccerComponent;
                }
                case SportConstant.Tennis: {
                    return MyBetsScoreboardTennisComponent;
                }
                case SportConstant.Basketball:
                case SportConstant.Icehockey:
                case SportConstant.AmericanFootball: {
                    const score = event.scoreboard.getScore<IcehockeyPeriodGameScore>();
                    if (score && score.penaltyShootOutScore) {
                        return MyBetsPenaltyShootoutScoreboardComponent;
                    }

                    return MyBetsScoreboardPeriodGameComponent;
                }
                case SportConstant.Darts: {
                    return MyBetsScoreboardDartsComponent;
                }
                case SportConstant.Snooker: {
                    return MyBetsSnookerScoreboardComponent;
                }
                case SportConstant.Formula1:
                case SportConstant.Skialpine:
                case SportConstant.Motorbikes:
                case SportConstant.Biathlon: {
                    return MyBetsLeaderboardGameScoreboardComponent;
                }
                case SportConstant.Baseball: {
                    return MyBetsBaseballScoreboardComponent;
                }
                default: {
                    if (event.scoreboard.type === ScoreboardType.PairGame) {
                        return MyBetsScoreboardPairComponent;
                    }

                    return MyBetsScoreboardSetComponent;
                }
            }
        } else {
            switch (event.sport.id) {
                case SportConstant.Formula1:
                case SportConstant.Skialpine:
                case SportConstant.Motorbikes:
                case SportConstant.Biathlon: {
                    return MyBetsLeaderboardGameScoreboardComponent;
                }
                default: {
                    return MyBetsTournamentGameScoreboardComponent;
                }
            }
        }
    }
}
